// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectParcelCharacteristicQueryResult, selectParcelCharacteristicsPageLoading, selectParcelCharacteristicsShowInitWaitingMessage} from '../_selectors/parcel-characteristic.selectors';

export class ParcelCharacteristicsDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectParcelCharacteristicsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectParcelCharacteristicsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectParcelCharacteristicQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
